var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipoIcoFundacionBi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.705,
    height: 32.704,
    viewBox: "0 0 32.705 32.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28006",
    "data-name": "Grupo 28006",
    transform: "translate(-839.977 -442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_147",
    "data-name": "Trazado 147",
    d: "M133.344,281.84v-1.168a4.672,4.672,0,0,0-9.344,0v1.168a4.672,4.672,0,0,0,9.344,0Zm-2.336,0a2.336,2.336,0,0,1-4.672,0v-1.168a2.336,2.336,0,0,1,4.672,0Z",
    transform: "translate(737.001 182.352)",
    fill: "#003765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_148",
    "data-name": "Trazado 148",
    d: "M131.344,285h-4.672A4.674,4.674,0,0,0,122,289.672a1.168,1.168,0,0,0,2.336,0,2.337,2.337,0,0,1,2.336-2.336h4.672a2.337,2.337,0,0,1,2.336,2.336,1.168,1.168,0,0,0,2.336,0A4.674,4.674,0,0,0,131.344,285Z",
    transform: "translate(736.665 183.864)",
    fill: "#003765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_149",
    "data-name": "Trazado 149",
    d: "M117.344,281.84v-1.168a4.672,4.672,0,0,0-9.344,0v1.168a4.672,4.672,0,0,0,9.344,0Zm-2.336,0a2.336,2.336,0,0,1-4.672,0v-1.168a2.336,2.336,0,0,1,4.672,0Z",
    transform: "translate(734.313 182.352)",
    fill: "#003765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_150",
    "data-name": "Trazado 150",
    d: "M115.344,285h-4.672A4.674,4.674,0,0,0,106,289.672a1.168,1.168,0,0,0,2.336,0,2.337,2.337,0,0,1,2.336-2.336h4.672a2.337,2.337,0,0,1,2.336,2.336,1.168,1.168,0,0,0,2.336,0A4.674,4.674,0,0,0,115.344,285Z",
    transform: "translate(733.977 183.864)",
    fill: "#003765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_151",
    "data-name": "Trazado 151",
    d: "M125.344,267.84v-1.168a4.672,4.672,0,0,0-9.344,0v1.168a4.672,4.672,0,0,0,9.344,0Zm-2.336,0a2.336,2.336,0,0,1-4.672,0v-1.168a2.336,2.336,0,0,1,4.672,0Z",
    transform: "translate(735.657 180)",
    fill: "#003765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_152",
    "data-name": "Trazado 152",
    d: "M123.344,271h-4.672A4.674,4.674,0,0,0,114,275.672a1.168,1.168,0,0,0,2.336,0,2.337,2.337,0,0,1,2.336-2.336h4.672a2.337,2.337,0,0,1,2.336,2.336,1.168,1.168,0,0,0,2.336,0A4.674,4.674,0,0,0,123.344,271Z",
    transform: "translate(735.321 181.512)",
    fill: "#003765"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipoIcoFundacionBi);
export default __webpack_public_path__ + "static/media/equipo-ico-fundacion-bi.d8a57f3a07b80f18d89f2222b73d9884.svg";
export { ForwardRef as ReactComponent };